/* eslint-disable @typescript-eslint/no-explicit-any */
import { CLASS_ID_PACKAGE } from '../constants';
const packageIdentifier = 'packageIdentifier';
const classIdentifier = 'classIdentifier';
const methodIdentifier = 'methodIdentifier';
const _id = '_id';
const body = 'body';
const checkDelegation = 'checkDelegation';
const delegationUser = 'delegationUser';
const queryParams = 'queryParams';
/**
 * Builds the params of a request.
 * @param args - Arguments for the construction of the parameters.
 * @returns Request params.
 */
export function buildRequestParams(args) {
    const { checkDelegation, delegationUser } = args;
    const { queryParams } = args;
    let { body } = args;
    let url = buildUrl(args);
    if (queryParams) {
        url = `${url}?${objectToQueryString(queryParams)}`;
    }
    body = checkDelegation ? Object.assign(Object.assign({}, body), { checkDelegation }) : body;
    body = delegationUser ? Object.assign(Object.assign({}, body), { delegationUser }) : body;
    return Object.assign(Object.assign(Object.assign({}, args.requestParams), { url }), (body ? { body } : {}));
}
function buildUrl(args) {
    const { packageIdentifier, classIdentifier } = args;
    const { _classId } = args;
    const { methodIdentifier } = args;
    const { _id } = args;
    let url = [];
    if (_classId) {
        url = [CLASS_ID_PACKAGE, _classId];
    }
    else if (classIdentifier && packageIdentifier) {
        url = [packageIdentifier, classIdentifier];
    }
    if (methodIdentifier) {
        url = [...url, methodIdentifier];
    }
    if (_id) {
        url.push(_id);
    }
    return url.join('/');
}
function objectToQueryString(queryParams) {
    queryParams = queryParams || {};
    return Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join('&');
}
